/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store';
import thunks from '../../store/series/thunks';
import { Row } from './ReportList.styles';
import ReportFCMain from './ReportFC/ReportFCMain';
import ReportFCUnsubmitted from './ReportFC/ReportFCUnsubmitted';
import { Report } from '../../types/Series';
import { ReportType, SUPPORTED_REPORTS_REQUEST_TYPES } from '@cambridgeassessment/lib-ee-commons';

interface Props {
  data: Report[];
  dataQaId?: string;
}

const ReportList: React.FC<Props> = ({ data, dataQaId }) => {
  const { reportsToGenerate, isSubmissionReportRequestLoading, submissionReportIndex } = useSelector(
    (state: RootState) => state.series,
  );
  const dispatch = useDispatch();

  useEffect(() => {
    return (): void => {
      dispatch(thunks.resetReportsBeingGenerated());
      dispatch(thunks.resetSubmissionReportRequest());
    };
  }, [dispatch]);

  const isReportBeingGenerated = (index: number): boolean => {
    const report = reportsToGenerate.find((value) => value === index);
    if (report === 0 || report) {
      return true;
    }
    return false;
  };

  const isReportBeingRequested = (index: number): boolean =>
    isSubmissionReportRequestLoading && submissionReportIndex === index;

  const renderReports = (reportArray: Report[]): JSX.Element[][] => {
    return reportArray.map((report, index) =>
      report.reports?.map((type) => (
        <Row colored={index % 2 === 0} key={`Series-${report.series.id}--Type-${type}`} data-qa-id={`${dataQaId}-row`}>
          {SUPPORTED_REPORTS_REQUEST_TYPES.includes(type as ReportType) ? (
            <ReportFCUnsubmitted
              type={type as ReportType}
              report={report}
              businessUnitId={report.businessUnitId}
              series={report.series}
              index={index}
              isBeingGenerated={isReportBeingRequested(index)}
            />
          ) : (
            <ReportFCMain
              type={type as ReportType}
              report={report}
              businessUnitId={report.businessUnitId}
              series={report.series}
              index={index}
              isBeingGenerated={isReportBeingGenerated(index)}
            />
          )}
        </Row>
      )),
    );
  };

  return <div>{renderReports(data)}</div>;
};

export default ReportList;
